import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

import InnerContainer from '../Shared/InnerContainer';
import Card from '../Shared/Card';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

const Research_Item = (props) => (
    <ProjectCard>
      <ProjectTitle>
        {props.proj.title}
        <ProjectInstitution>
          ({props.proj.institution})
        </ProjectInstitution>
      </ProjectTitle>
      <ProjectDescription
        dangerouslySetInnerHTML={{__html: marked(props.proj.description.description, {sanitize: true})}}>
      </ProjectDescription>
      {props.proj.relavantPapers && <h4 style={{ margin: '1.5rem 0', fontSize: '1.1rem', fontWeight: '400' }}>Relevant Papers</h4>}
      {props.proj.relavantPapers &&
        props.proj.relavantPapers.map((paper, i) => {
          console.log(paper);
          return <RelevantPapers key={i}>
              <p>{paper.title}</p>
              <a href={paper.abstractUrl} target="_blank">{paper.doiNumber}</a>
            </RelevantPapers>
        })}
    </ProjectCard>
);

export default Research_Item;


const ProjectCard = Card.extend`
  margin: 0px 0px 40px;
`;

const ProjectTitle = styled.h2`
  font-weight: 400;
  line-height: 1.8rem;
  font-size: 1.5rem;
  margin: 0px 0px .5rem;
  letter-spacing: 0.25px;
`;

const ProjectInstitution = styled.span`
  font-weight: 300;
  line-height: 1.8rem;
  font-size: 1.5rem;
  margin: 0px 0px .5rem;
  opacity: 0.5;
  padding-left: 0.5rem;
`;

const ProjectDescription = styled.p`
  line-height: 1.5rem;
  font-size: 1.1rem;
  margin: 0px 0px .5rem;
  opacity: 1;
  ${'' /* font-family: Open Sans; */}
  font-weight: 300;
  letter-spacing: 0.25px;
`;

const RelevantPapers = Card.extend`
  padding: 10px 20px;
  margin: 10px 0px;
  color: steelblue;
  border-left: 5px solid steelblue;

  & p {
    margin-bottom: 0.25rem;
  }

  & a {
    color: #333;
    opacity: 0.8;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Research_Item/index.js